import { AsyncPipe } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, ViewChild, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TimeFrameSelectionComponent } from '@components/time-frame-selection/time-frame-selection.component';
import { ChartBindingDirective } from '@utils/chart-interactive/chart-controller.directive';
import { CHART_ZOOM as CHART_INTERACTIVE_ZOOM, ChartTimeframeControllerDirective } from '@utils/chart-interactive/chart-timeframe-controller.directive';
import { DataToTimeframePipe } from '@utils/chart-interactive/data-to-timeframe.pipe';
import { TimeframePreselectionDirective } from '@utils/chart-interactive/timeframe-preselection.directive';
import { valueDevelopmentLinieOptionsTransformer } from '@utils/charts/chart-transformers';
import { HighchartsDirective, HighchartsSizeStrategy } from '@utils/charts/highcharts.directive';
import { legacyOptionsTransformer } from '@utils/charts/legacy-chart-options.pipe';
import { TransformChartOptionsPipe } from '@utils/charts/transform-chart-options.pipe';
import * as Highcharts from 'highcharts';
import * as Highstock from 'highcharts/highstock';
import { Subject } from 'rxjs';
import iconLibrary from 'src/app/common/iconLibrary';
import { ElementPipe } from 'src/app/element-handling/element.pipe';
import { DatepickerComponent } from './datepicker/datepicker.component';

@Component({
  selector: 'wct-value-development-chart',
  standalone: true,
  imports: [
    TimeFrameSelectionComponent,
    DatepickerComponent,

    TransformChartOptionsPipe,
    ElementPipe,
    AsyncPipe,
    DataToTimeframePipe,

    HighchartsDirective,
    ChartBindingDirective,
    ChartTimeframeControllerDirective,
    TimeframePreselectionDirective,
  ],
  templateUrl: './value-development-chart.component.html',
  styleUrl: './value-development-chart.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    {
      provide: CHART_INTERACTIVE_ZOOM,
      useFactory: () => new EventEmitter(),
    }
  ]
})
export class ValueDevelopmentChartComponent implements OnDestroy {
  @Input({ required: true }) public data: Highcharts.Options;
  @Input({ required: false }) sizeStrategy?: HighchartsSizeStrategy | undefined;

  @ViewChild(TimeFrameSelectionComponent, { static: true })
  protected timeFrameSelection: TimeFrameSelectionComponent;

  protected readonly Highstock = Highstock;
  protected readonly iconLibrary = iconLibrary;

  protected readonly legacyOptionsTransformer = legacyOptionsTransformer;
  protected readonly chartTransformer: (options: Highcharts.Options) => Highcharts.Options;

  private readonly zoom: Subject<[Highcharts.Axis, Highcharts.AxisSetExtremesEventObject]> = inject(CHART_INTERACTIVE_ZOOM);
  private readonly cdr: ChangeDetectorRef = inject(ChangeDetectorRef);

  constructor() {
    this.zoom.pipe(takeUntilDestroyed()).subscribe(() => {
      this.timeFrameSelection.resetSelection();
      setTimeout(() => {
        this.cdr.detectChanges();
      });
    })

    this.chartTransformer = valueDevelopmentLinieOptionsTransformer(this.zoom);
  }

  ngOnDestroy(): void {
    this.zoom.complete();
  }
}
